"use client";

import Link from "next/link";

interface NavItem {
  href: string;
  label: string;
}

interface BottomNavigationProps {
  previous?: NavItem | null;
  next?: NavItem | null;
}

export default function BottomNavigation({ previous, next }: BottomNavigationProps) {
  return (
    <div className="max-w-6xl mx-auto bg-white border-t border-b border-gray-200 py-7 mt-10">
      <div className="px-4 flex items-center justify-between">

        {/* PREVIOUS */}
        {previous ? (
          <Link
            href={previous.href}
            className="group flex items-center gap-3 transition"
          >
            <div className="w-10 h-10 rounded-full flex items-center justify-center bg-[#F9F9F9] 
                           transition-all duration-300 hover:scale-105  hover:bg-[#F3F3F3] 
            ">
              <svg width="20" height="20" className="text-[#08264C]" viewBox="0 0 24 24">
                <path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" fill="none"/>
              </svg>
            </div>
            <span className="font-space-grotesk font-bold text-lg transition-all duration-300 hover:text-[#3F74EF]">{previous.label}</span>
          </Link>
        ) : (
          <div />
        )}

        {/* NEXT */}
        {next ? (
          <Link
            href={next.href}
            className="group flex items-center gap-3 transition"
          >
            <span className="font-space-grotesk font-bold text-lg transition-all duration-300 hover:text-[#3F74EF]">{next.label}</span>
            <div className="w-10 h-10 rounded-full flex items-center justify-center bg-gradient-to-r from-[#08264C] to-[#3F74EF]
                            transition-all duration-300 hover:scale-105
            ">
              <svg width="20" height="20" className="text-white" viewBox="0 0 24 24">
                <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" fill="none"/>
              </svg>
            </div>
          </Link>
        ) : (
          <div />
        )}

      </div>
    </div>
  );
}
